module.exports = __webpack_public_path__ + "3296bb208816a0d182b903e5017ccb4e.svg";